import React from 'react'
import moment from 'moment'
import { formatTwoDigitValue } from '../../../../helper/common'
import { IconResultHasViolation, IconResultNoViolation } from '../../../../assets/icons'
import useThemeFeatureConfig from '../../../../hooks/common/useThemeFeatureConfig'
import './index.scss'

export const PARTNER_NAME = {
  BIDV: 'BIDV'
}

export default function ResultCriminalCard({
      isVehicleWarning = 0,
      checkedAt,
      vehicleType,
      vehicleIdentity = '',
      criminalCount = 0,
      partnerName = ''
    }) {
  const { noViolationText, checkedAtLabel } = useThemeFeatureConfig('RESULT_CRIMINAL_CARD')

  const hasCriminal = String(isVehicleWarning) === '1' || isVehicleWarning === 1 || isVehicleWarning === true
  const checkedAtText = moment(checkedAt || new Date()).format('HH:mm, DD/MM/YYYY')
  const HeroIcon = hasCriminal ? IconResultHasViolation : IconResultNoViolation
  const criminalCountNumber = Number(criminalCount)
  const criminalCountText = formatTwoDigitValue(Number.isFinite(criminalCountNumber) ? Math.max(0, criminalCountNumber) : null, '00')

  return (
    <div className="ResultCriminalCard">
      <div className="ResultCriminalCard_center">
        <div className="ResultCriminalCard_imageWrap">
          <HeroIcon className="ResultCriminalCard_image" />
          <div className={`ResultCriminalCard_plate ${hasCriminal ? 'ResultCriminalCard_plate_warning' : 'ResultCriminalCard_plate_success'}`}>
            <span>{String(vehicleIdentity || '').toUpperCase()}</span>
          </div>
        </div>

        <div className={`ResultCriminalCard_title`}>
          {hasCriminal ? (
            <>
              Phát hiện xe có <span className="ResultCriminalCard_titleCount">{criminalCountText}</span> lỗi vi phạm
            </>
          ) : (
            <div style={{ whiteSpace: 'pre-line' }}>{noViolationText}</div>
          )}
        </div>

        <div className="ResultCriminalCard_checkedAt">
          {checkedAtLabel} {checkedAtText}
        </div>
      </div>
    </div>
  )
}
